module.exports = __webpack_public_path__ + "img/features_privacymaster_mobile.e55e99af.png";